// extracted by mini-css-extract-plugin
module.exports = {"microCard":"ProductDetailsPanel_microCard__sa5wm"};